import OBCProgressBar from "components/OBC/OBCProgressBar";
import OBCSearchInput from "components/OBC/OBCSearchInput";
import _ from "lodash";
import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import { useSelector } from "react-redux";

const availableTrainingCategoriesListSelector = (state) => state.driverTraining.admin.availableTrainingCategoriesList;

const SessionsTab = () => {
    const availableTrainingCategoriesList = useSelector(availableTrainingCategoriesListSelector);

    const [trainingListSearchQuery, setTrainingListSearchQuery] = useState("");

    const selectCategory = (category) => {
        console.log("debug selectCategory");
    };

    return (
        <div className="TrainingSessionsTab">
            <div className="TabMainLeftCol">
                <OBCSearchInput
                    value={trainingListSearchQuery}
                    onChange={setTrainingListSearchQuery}
                    placeholder="Search for traning"
                />
                <div className="TraningsList">
                    {_.map(availableTrainingCategoriesList, (category) => {
                        // return <div>Name: {category.name}</div>
                        return (
                            <div
                                key={category.id}
                                className={`DriverListItem`}
                                onClick={() => selectCategory(category)}>
                                <span className="Title">
                                    <Highlighter
                                        highlightClassName="ObcTextHighlight"
                                        searchWords={trainingListSearchQuery.split(" ")}
                                        autoEscape={true}
                                        textToHighlight={category.name}
                                    />
                                </span>
                                <span className="SubTitle">Last activity: No activity yet</span>
                                <OBCProgressBar
                                    className="DriverListProgressBar"
                                    lableVisible={false}
                                    progress={0.2}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="TabMainRightCol">Manage Sessions RIGHT COL</div>
        </div>
    );
};

export default SessionsTab;
